import { Controller } from "@hotwired/stimulus"
import { selectAll, setDisabled } from "../../shared/multi_select"

export default class extends Controller {
  connect() {
    const checked = document.getElementById("checkbox-sent-to-all")?.checked ?? true
    setDisabled(document.getElementById("select-team-ids"), checked)
  }

  change(event) {
    setDisabled(document.getElementById("select-team-ids"), event.target.checked)
  }

  select_all(event) {
    event.preventDefault()
    const select = document.getElementById("select-team-ids")
    setDisabled(select, false)
    selectAll(select)
    document.getElementById("checkbox-sent-to-all").checked = false
  }
}
